import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["viewMode", "editMode", "viewButtons", "editButtons", "emailInput", "emailNotice"]
  static values = { editing: Boolean }

  connect() {
    this.originalEmail = this.hasEmailInputTarget ? this.emailInputTarget.dataset.originalEmail : null
    if (this.hasEmailInputTarget) {
      this.emailInputTarget.addEventListener("input", this.checkEmailChanged.bind(this))
    }
  }

  startEdit() {
    this.editingValue = true
    this.updateUI()
  }

  cancelEdit() {
    this.editingValue = false
    // Reset email input to original
    if (this.hasEmailInputTarget && this.originalEmail) {
      this.emailInputTarget.value = this.originalEmail
    }
    this.updateUI()
  }

  updateUI() {
    if (this.editingValue) {
      this.viewModeTarget.classList.add("hidden")
      this.editModeTarget.classList.remove("hidden")
      this.viewButtonsTarget.classList.add("hidden")
      this.editButtonsTarget.classList.remove("hidden")
      // Add green border indicator to the controller element
      this.element.classList.add("border-l-4", "border-[#117D4B]")
    } else {
      this.viewModeTarget.classList.remove("hidden")
      this.editModeTarget.classList.add("hidden")
      this.viewButtonsTarget.classList.remove("hidden")
      this.editButtonsTarget.classList.add("hidden")
      // Remove green border indicator
      this.element.classList.remove("border-l-4", "border-[#117D4B]")
      this.hideEmailNotice()
    }
  }

  checkEmailChanged() {
    if (!this.hasEmailInputTarget || !this.originalEmail) return

    const currentEmail = this.emailInputTarget.value.toLowerCase().trim()
    const originalEmail = this.originalEmail.toLowerCase().trim()

    if (currentEmail !== originalEmail && currentEmail.length > 0) {
      this.showEmailNotice()
    } else {
      this.hideEmailNotice()
    }
  }

  showEmailNotice() {
    if (this.hasEmailNoticeTarget) {
      this.emailNoticeTarget.classList.remove("hidden")
    }
  }

  hideEmailNotice() {
    if (this.hasEmailNoticeTarget) {
      this.emailNoticeTarget.classList.add("hidden")
    }
  }

  async submitWithEmailCheck(event) {
    if (!this.hasEmailInputTarget) return

    const currentEmail = this.emailInputTarget.value.toLowerCase().trim()
    const originalEmail = this.originalEmail.toLowerCase().trim()

    if (currentEmail !== originalEmail) {
      event.preventDefault()

      // Get the profile settings controller
      const profileSettingsController = this.application.getControllerForElementAndIdentifier(
        document.querySelector('[data-controller="profile-settings"]'),
        "profile-settings"
      )

      if (profileSettingsController) {
        const result = await profileSettingsController.sendEmailVerification(currentEmail)
        if (!result.success) {
          alert(result.error)
        }
      }
    }
  }
}
